// src/modules/gyms/utils/time.utils.ts

export const getTodayKey = (): string => {
  const days = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  return days[new Date().getDay()];
};

export const isCurrentlyOpen = (from: string, to: string): boolean => {
  const now = new Date();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const [fromHour, fromMin] = from.split(":").map(Number);
  const [toHour, toMin] = to.split(":").map(Number);
  const fromMinutes = fromHour * 60 + fromMin;
  const toMinutes = toHour * 60 + toMin;
  return currentMinutes >= fromMinutes && currentMinutes < toMinutes;
};

export const getTodayHours = (
  openingHours?: Record<string, { start_time: string; end_time: string }>,
  defaultFrom?: string,
  defaultTo?: string,
): { from: string; to: string } => {
  const todayKey = getTodayKey();
  if (openingHours && openingHours[todayKey]) {
    const { start_time, end_time } = openingHours[todayKey];
    // Chỉ trả về nếu giờ hợp lệ (khác 00:00)
    if (
      start_time &&
      end_time &&
      start_time !== "00:00" &&
      end_time !== "00:00"
    ) {
      return { from: start_time, to: end_time };
    }
  }
  return { from: defaultFrom || "06:00", to: defaultTo || "22:00" };
};
